import { render, staticRenderFns } from "./AlertWindow.vue?vue&type=template&id=46579d52&"
import script from "./AlertWindow.vue?vue&type=script&lang=js&"
export * from "./AlertWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports